import FeedbackPage from "@components/FeedbackPage"

export default function Motivational2() {
  return (
    <FeedbackPage
      emoji="🌟"
      titleKey="pages.onboarding.motivational2.heading"
      textKey="pages.onboarding.motivational2.info"
      buttonKey="pages.onboarding.motivational2.button"
    />
  )
}
